(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	// Sticky bar reveal. Offsets are measured once per layout change (init,
	// section load, resize) and cached; the scroll handler then only compares
	// window.scrollY against the cache, so no getBoundingClientRect() runs per
	// scroll event. The scroll listener is bound exactly once - it is registered
	// outside revealPopup(), which callers may invoke repeatedly.
	// A PDP without the floated_form block simply has no bar: that is a valid
	// configuration, not an error, so it clears the cache and returns quietly
	// instead of logging.
	let stickyBarState = null;

	const measureStickyBar = () => {
		const stickyBar = document.querySelector('.product__popup');
		const secondSection = document.querySelector('.product-section + section');
		const footer = document.querySelector('footer');

		if (!stickyBar || !secondSection || !footer) {
			stickyBarState = null;
			return;
		}

		const offsetTop = (element) =>
			element.getBoundingClientRect().top + window.scrollY;

		stickyBarState = {
			stickyBar: stickyBar,
			revealAfter: offsetTop(secondSection),
			hideBefore: offsetTop(footer),
		};
	};

	const applyStickyBarState = () => {
		if (!stickyBarState) return;
		const scrollTop = window.scrollY;
		const active =
			scrollTop > stickyBarState.revealAfter &&
			scrollTop + window.innerHeight < stickyBarState.hideBefore;

		stickyBarState.stickyBar.classList.toggle('active', active);
	};

	const revealPopup = () => {
		measureStickyBar();
		applyStickyBarState();
	};

	// rAF-coalesced: many scroll events collapse into one class-toggle per frame.
	let stickyBarFrame = 0;
	document.addEventListener(
		'scroll',
		() => {
			if (stickyBarFrame) return;
			stickyBarFrame = requestAnimationFrame(() => {
				stickyBarFrame = 0;
				applyStickyBarState();
			});
		},
		{ passive: true }
	);

	// Offsets are viewport-dependent, so re-measure when the layout can change.
	// The old code got this for free by re-measuring on every scroll event; a
	// body ResizeObserver covers the same cases (lazy images settling, the
	// floated-form clone rendering, breakpoint changes) without the per-event
	// layout reads.
	window.addEventListener('resize', revealPopup);
	if (window.ResizeObserver) {
		new ResizeObserver(revealPopup).observe(document.documentElement);
	}

	// Keep the sticky bar's cloned form on the variant the shopper actually
	// selected. variant-selects.updateVariantInput() (global.js) scopes its
	// lookup to `#product-form-<section>`, and preventDuplicatedIDs() rewrites
	// the clone's section to `floated-<section>` - so a selection made in the
	// main info column never reached the bar's hidden id input. On mobile the
	// bar has no swatch row of its own (condensed layout), so without this the
	// bar's Add to Bag would post whichever variant the clone was fetched with.
	const syncStickyBarVariant = () => {
		const source = document.querySelector(
			'[id^="ProductInfo-"] form input[name="id"]'
		);
		if (!source || !source.value) return;
		document
			.querySelectorAll('.product__popup form input[name="id"]')
			.forEach((input) => {
				if (input.value !== source.value) input.value = source.value;
			});
	};

	document.addEventListener("change", (event) => {
		const input = event.target;
		if (!input || input.name !== "id") return;
		// Only mirror main-column -> bar; the bar's own picker (desktop) already
		// updates its own form, and mirroring back would fight it.
		if (!input.closest('[id^="ProductInfo-"]')) return;
		if (input.closest(".product__popup")) return;
		syncStickyBarVariant();
	});

	// The clone fetches product.url without a variant param, so a page opened on
	// a deep-linked ?variant= lands with the bar on the default variant.
	document.addEventListener("floated-form:rendered", syncStickyBarVariant);

	// Productive #246 - the desktop bar carries a copy of the size picker. Its
	// radios are PROXIES: a change there is stopped before the clone's own
	// variant-radios can act on it (that element binds its change handler on
	// itself, so a capture-phase stop at document runs first) and replayed on
	// the matching radio in the main column. The main picker then does the
	// real work - form id, URL, media, notify state - and the mirrors below
	// bring the bar back in line. Bar -> main, never the reverse.
	const mainRadio = (name, value) =>
		Array.from(
			document.querySelectorAll(
				'[id^="ProductInfo-"] variant-radios input[type="radio"]'
			)
		).find((radio) => radio.name === name && radio.value === value);

	document.addEventListener(
		"change",
		(event) => {
			const input = event.target;
			if (!(input instanceof HTMLInputElement) || input.type !== "radio") return;
			if (!input.closest(".product__popup variant-radios")) return;
			event.stopPropagation();
			const target = mainRadio(input.name, input.value);
			if (!target || target.checked) return;
			target.checked = true;
			target.dispatchEvent(new Event("change", { bubbles: true }));
		},
		true
	);

	// Main -> bar: the bar's radios show whatever the main picker holds. Runs
	// on every variant change and once the clone has rendered (it is fetched
	// without a variant param, so it lands on the default size).
	const syncStickyBarPicker = () => {
		document
			.querySelectorAll('.product__popup variant-radios input[type="radio"]')
			.forEach((radio) => {
				const source = mainRadio(radio.name, radio.value);
				if (source) radio.checked = source.checked;
			});
	};
	document.addEventListener("variant:change", syncStickyBarPicker);
	document.addEventListener("floated-form:rendered", syncStickyBarPicker);

	// Productive #249 - the bar's Add to Bag must follow the selection's stock
	// state. The main column relabels its own button (variant-selects ->
	// toggleAddButton scopes to #product-form-<section>) and shows the Notify
	// CTA, but the clone in the bar kept an enabled "Add to Bag" for a sold-out
	// size - and on mobile the bar IS the buy control once the shopper scrolls
	// past the buy block (the notify block is deliberately not cloned into it,
	// see removeDOMElements). So the bar's button becomes the notify CTA when
	// the selection is unavailable and the PDP has a notify block: it takes the
	// notify label, stops acting as a submit, and proxies its click to the main
	// column's trigger (the Back in Stock widget's [data-bis-app-block], or the
	// no-app modal fallback - whichever the theme is currently showing). With
	// no notify block it reads Sold Out / Coming Soon and is disabled, exactly
	// like the main button. Back in stock -> plain submit again.
	const STICKY_NOTIFY_ATTR = "data-sticky-notify";

	const mainNotifyTrigger = () => {
		const wrap = document.querySelector('[id^="ProductInfo-"] .notify-button');
		if (!wrap) return null;
		return wrap.classList.contains("notify-button--bis-ready")
			? wrap.querySelector("[data-bis-app-block]")
			: wrap.querySelector(".notify-button__fallback button");
	};

	// Productive #312 - pre-order sizes read "Pre Order" in the bar too. Read the
	// variant map the main column renders (pdp-preorder-message) for the variant
	// the event carries; variant:change fires before toggleAddButton has relabelled
	// the main button, so its data-preorder flag is only the fallback.
	const preorderEntry = (variant) => {
		const source = document.querySelector(
			'[id^="ProductInfo-"] [data-preorder-variants]'
		);
		if (!source || !variant || !variant.available) return null;
		try {
			const entry = JSON.parse(source.textContent)[String(variant.id)];
			return entry && entry.preorder ? entry : null;
		} catch (error) {
			return null;
		}
	};

	const syncStickyBarAvailability = (available, variant) => {
		const mainSubmit = document.querySelector(
			'[id^="ProductInfo-"] .product-form__submit'
		);
		if (typeof available !== "boolean") {
			// No variant handed in (bar just rendered): read the main column.
			if (!mainSubmit) return;
			available = !mainSubmit.hasAttribute("disabled");
		}
		const strings = window.variantStrings || {};
		const comingSoon = !!mainSubmit?.hasAttribute("data-coming-soon");
		const notifyLabel = (document.querySelector(
			'[id^="ProductInfo-"] .notify-button .notify-open-button span'
		) || {}).textContent;

		document
			.querySelectorAll(".product__popup .product-form__submit")
			.forEach((button) => {
				const label = button.querySelector("span") || button;
				if (available) {
					button.removeAttribute(STICKY_NOTIFY_ATTR);
					button.removeAttribute("disabled");
					button.setAttribute("type", "submit");
					const preorder = variant
						? !!preorderEntry(variant)
						: !!mainSubmit?.hasAttribute("data-preorder");
					const addLabel = preorder
						? strings.preOrder || strings.addToCart
						: strings.addToCart;
					if (addLabel) label.textContent = addLabel;
					return;
				}
				if (mainNotifyTrigger() && notifyLabel) {
					button.setAttribute(STICKY_NOTIFY_ATTR, "true");
					button.setAttribute("type", "button");
					button.removeAttribute("disabled");
					label.textContent = notifyLabel.trim();
					return;
				}
				button.removeAttribute(STICKY_NOTIFY_ATTR);
				button.setAttribute("type", "submit");
				button.setAttribute("disabled", "disabled");
				label.textContent = comingSoon
					? strings.comingSoon || label.textContent
					: strings.soldOut || label.textContent;
			});
	};

	document.addEventListener("variant:change", (event) => {
		const variant = event.detail && event.detail.variant;
		if (!variant) return;
		syncStickyBarAvailability(!!variant.available, variant);
	});
	document.addEventListener("floated-form:rendered", () => {
		// toggleAddButton has already run for the deep-linked variant by the time
		// the clone renders; a tick lets the clone's own markup settle first.
		setTimeout(() => syncStickyBarAvailability(), 0);
	});
	document.addEventListener("click", (event) => {
		const button =
			event.target.closest &&
			event.target.closest(
				`.product__popup .product-form__submit[${STICKY_NOTIFY_ATTR}]`
			);
		if (!button) return;
		event.preventDefault();
		const trigger = mainNotifyTrigger();
		if (trigger) trigger.click();
	});


	// Billini static gallery rail (Figma 11169:48392): the static_column_aside
	// thumb rail has no swiper -- a thumb click smooth-scrolls its media item
	// into view, and an IntersectionObserver tracks the visible item to mark
	// the matching thumb .is-active.
	const initStaticGalleryRail = () => {
		document
			.querySelectorAll(".product__media-sublist-outer--static")
			.forEach((rail) => {
				if (rail.dataset.railInit) return;
				rail.dataset.railInit = "true";

				const wrapper = rail.closest(".product__media-list-wrapper");
				if (!wrapper) return;
				const items = wrapper.querySelectorAll(
					".product__media-list .product__media-item"
				);
				const thumbs = rail.querySelectorAll(".product__media-subitem");
				if (!items.length || !thumbs.length) return;

				const itemFor = (thumb) => {
					const id = thumb.dataset.mediaSubId;
					return wrapper.querySelector(
						`.product__media-list [data-media-id="${id}"]`
					);
				};

				thumbs.forEach((thumb) => {
					thumb.addEventListener("click", () => {
						const item = itemFor(thumb);
						if (item) item.scrollIntoView({ behavior: "smooth", block: "center" });
					});
				});

				const setActive = (mediaId) => {
					thumbs.forEach((thumb) => {
						thumb.classList.toggle(
							"is-active",
							thumb.dataset.mediaSubId === mediaId
						);
					});
				};

				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) setActive(entry.target.dataset.mediaId);
						});
					},
					{ rootMargin: "-45% 0px -45% 0px" }
				);
				items.forEach((item) => observer.observe(item));

				if (items[0]) setActive(items[0].dataset.mediaId);
			});
	};

	// Back in Stock (useAMP) owns the [data-bis-app-block] notify CTA: it resolves
	// the selected variant, reveals the trigger, and opens its own capture form.
	// The static modal fallback renders by default so an out-of-stock product
	// always has an actionable CTA; once the widget takes over, retire it so only
	// one CTA shows.
	const initNotifyFallback = () => {
		// Scope to the main info column - the sticky bar is a clone and must not
		// be the element we measure or swap.
		document
			.querySelectorAll('[id^="ProductInfo-"] .notify-button')
			.forEach((wrap) => {
				const trigger = wrap.querySelector("[data-bis-app-block]");
				if (!trigger) return;

				const promote = () => {
					if (!window.BISPopover) return false;
					wrap.classList.add("notify-button--bis-ready");
					return true;
				};

				if (promote()) return;
				// The app embed loads async; poll briefly, then leave the fallback in
				// place if the widget never arrives.
				let waited = 0;
				const poll = setInterval(() => {
					waited += 250;
					if (promote() || waited >= 5000) clearInterval(poll);
				}, 250);
			});
	};

	// True Fit owns the "What's my Size?" destination. Its app block renders a
	// <tf-recommendation> element whose CTA and modal live in a closed-to-CSS
	// shadow root, so the design's control cannot be achieved by restyling it.
	// Instead the theme renders its own button and proxies clicks into the app's
	// CTA, which opens True Fit's <dialog>.
	//
	// True Fit also decides whether a recommendation exists at all: on a product
	// it has no fit model for the shadow root renders empty. The theme button is
	// therefore `hidden` in Liquid and only revealed while that CTA is present -
	// and re-hidden if a variant change makes it go away - so an unconfigured
	// product never shows a control that does nothing.
	const TF_CTA = '[data-truefit-id="pdpCta.button"]';
	const initWhatsMySize = () => {
		// Scope to the main info column: the sticky bar is a clone of it and the
		// app block only ever renders once, in the column.
		document
			.querySelectorAll('[id^="ProductInfo-"] [data-whats-my-size]')
			.forEach((button) => {
				if (button.dataset.whatsMySizeBound) return;
				button.dataset.whatsMySizeBound = "true";

				const shadow = () =>
					document.querySelector("tf-recommendation")?.shadowRoot ?? null;

				button.addEventListener("click", () => {
					shadow()?.querySelector(TF_CTA)?.click();
				});

				// The app's own CTA has to stay in the DOM and clickable for the
				// proxy to work, so clip it rather than display:none it. Light-DOM
				// CSS cannot reach into the shadow root, hence the injected style.
				const clipAppCta = (root) => {
					if (root.querySelector("style[data-theme-tf-clip]")) return;
					const style = document.createElement("style");
					style.setAttribute("data-theme-tf-clip", "");
					style.textContent = `${TF_CTA}{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;overflow:hidden!important;clip-path:inset(50%)!important;white-space:nowrap!important}`;
					root.appendChild(style);
				};

				// Clipping leaves the app's CTA in the tab order and the a11y tree,
				// so keyboard and screen-reader users would meet the same control
				// twice. The theme button is the one that is announced; retire the
				// app's copy from both.
				const retireAppCta = (cta) => {
					cta.setAttribute("aria-hidden", "true");
					cta.setAttribute("tabindex", "-1");
				};

				const sync = (root) => {
					const cta = root.querySelector(TF_CTA);
					button.hidden = !cta;
					if (!cta) return;
					clipAppCta(root);
					retireAppCta(cta);
				};

				// The app embed loads async; poll briefly for the shadow root, then
				// let a MutationObserver track the CTA coming and going. If True Fit
				// never arrives the button simply stays hidden.
				let waited = 0;
				const poll = setInterval(() => {
					const root = shadow();
					waited += 250;
					if (root) {
						clearInterval(poll);
						sync(root);
						new MutationObserver(() => sync(root)).observe(root, {
							childList: true,
							subtree: true,
						});
					} else if (waited >= 5000) {
						clearInterval(poll);
					}
				}, 250);
			});
	};

	// Productive #302 - the size header reads "Size: <selected>". The value is
	// server-rendered from option.selected_value; keep it on the radio the shopper
	// picks. Delegated so the sticky bar's proxy radios (which forward to the main
	// column's inputs) and the theme editor's section reloads need no rebinding.
	document.addEventListener("change", (event) => {
		const input = event.target;
		if (!(input instanceof HTMLInputElement) || input.type !== "radio") return;
		const fieldset = input.closest(".product-form__controls");
		const current = fieldset?.querySelector("[data-size-current]");
		if (current) current.textContent = input.value;
	});

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
		initStaticGalleryRail();
		initNotifyFallback();
		initWhatsMySize();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
	initStaticGalleryRail();
	initNotifyFallback();
	initWhatsMySize();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();

				// The bar's form only exists once the clone has rendered - let the
				// variant sync above pick up the shopper's current selection.
				document.dispatchEvent(new CustomEvent("floated-form:rendered"));
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		// The out-of-stock notice and the notify CTA belong to the main info column
		// only - the sticky bar signals sold-out by relabelling its button
		// (pdp-sticky-cta spec). Cloning the notify wrapper would also duplicate
		// [data-bis-app-block] and its id, leaving the Back in Stock widget with
		// two triggers to bind.
		const stockMessage = this.productElement.querySelector(
			"[data-pdp-stock-message]"
		);
		if (stockMessage) stockMessage.remove();

		const notifyButton = this.productElement.querySelector(".notify-button");
		if (notifyButton) notifyButton.remove();

		// Same reasoning for the True Fit app block: the bar has no size-guide row
		// to proxy from, and a second <tf-recommendation> would mount the app's own
		// unstyled CTA into the sticky bar.
		this.productElement
			.querySelectorAll(".tfc-fitrec-product")
			.forEach((widget) => widget.remove());

		// And the Yotpo star-rating app block: the sticky bar shows title + price
		// only, and a second .yotpo-widget-instance for the same instance id leaves
		// the widget with two mount points for one rating.
		this.productElement
			.querySelectorAll(".yotpo-widget-instance")
			.forEach((widget) => widget.remove());

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		// The clone exists for one control only: the sticky bar's Add to Bag
		// (Figma Sticky CTA 10160:55538 draws thumbnail + name/price + colour
		// swatches + ATC; name/price/swatches are rendered by the bar's own
		// markup). Everything else in the details column - the variant column,
		// size-guide row, BNPL, find-in-store, accordions, and the app blocks -
		// is main-column furniture that dragged the clone to 302px inside a
		// 74px bar. Allow-list rather than deny-list: a new details block added
		// to the column must not silently reappear in the bar.
		//
		// Keeping .product__buy_buttons intact preserves the /cart/add contract
		// (product-form owns the <form>, the hidden [name=id] input, the error
		// wrapper and the loading spinner); syncStickyBarVariant keeps that
		// input on the shopper's selection.
		const buyButtons = this.productElement.querySelector(
			".product__buy_buttons"
		);
		const content = this.productElement.querySelector(
			".product__info-main_content"
		);
		// A PDP with the buy_buttons block removed has no ATC to float, so the
		// bar empties rather than falling back to the whole column.
		// Productive #246 (client decision) - the desktop bar also carries the
		// size picker, so a shopper who scrolled past the details column can
		// still choose a size before Add to Bag. The Figma bar (10160:55538)
		// draws colourways + ATC only, so this is an addition to the drawing.
		// Only the variant picker itself comes along - the colour swatches, fit
		// chips and stock message in the same column stay main-column
		// furniture. Its radios are proxies for the main column's picker (see
		// the capture-phase change handler above), so the two never disagree.
		const sizePicker = this.productElement.querySelector(
			".product__variant-column .product-parameters"
		);
		// The "Size: <n>" header row (Productive #302) is main-column furniture
		// too - the bar has no room for a label or the size-guide link.
		sizePicker
			?.querySelectorAll(".size-guide-btn, modal-opener, .pdp-size__header")
			.forEach((el) => el.remove());
		if (content) {
			content.replaceChildren(
				...(buyButtons ? [sizePicker, buyButtons].filter(Boolean) : [])
			);
		}

		// These all live INSIDE the buy-buttons block, so the allow-list above
		// keeps them - and none is drawn in the sticky bar (the Figma bar's own
		// Promo Line, 10160:55525, is hidden). The BNPL line in particular added
		// 40px under the button and pushed the bar's content past its 74px box.
		buyButtons
			?.querySelectorAll(
				".pdp-size-guide-row, .pdp-wishlist-button, .pdp-bnpl, .pdp-find-in-store"
			)
			.forEach((el) => el.remove());

		// The sticky bar's styling must be independent of the main ATC: while
		// the clone carries the details column's class names, every
		// `.product__info-main_content ...` rule in section_pdp_details also
		// matches inside the bar (that is how the disabled-state fill and the
		// full-width ATC leaked in). Swap the two wrapper classes for bar-owned
		// ones so the bar inherits nothing from the column by class name - the
		// cart JS addresses the form by element (product-form / form /
		// [name=id]), never by these wrappers, so the /cart/add contract is
		// unaffected. The buy-buttons block keeps its own class: it IS the
		// shared ATC primitive, and the bar restyles it under .product__popup.
		content?.classList.remove("product__info-main_content--pdp");
		content?.classList.replace(
			"product__info-main_content",
			"product__popup_form-content"
		);
		this.productElement
			.querySelectorAll(".product__info-main")
			.forEach((el) => el.classList.replace("product__info-main", "product__popup_form"));

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
